import { render, staticRenderFns } from "./SuggestFeatureModal.vue?vue&type=template&id=2dc8dfca&"
import script from "./SuggestFeatureModal.vue?vue&type=script&lang=js&"
export * from "./SuggestFeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./SuggestFeatureModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports